import { useSearchParams } from "react-router-dom";
import { AcceptedFeatures } from "../Shared/shared.consts";
import { FeatureKeyType } from "../Types";
import { debugWarn } from "../Shared/shared.utils";

export function useGetFeatureParam(
  featureKey: FeatureKeyType,
): string | boolean | number | undefined {
  const [searchParam, _] = useSearchParams();

  if (!(featureKey in AcceptedFeatures)) {
    debugWarn(`Feature key ${featureKey} is not recognized.`);
    return undefined;
  }

  const featureConfig = AcceptedFeatures[featureKey];
  const featureType = featureConfig.type;
  const rawValue = searchParam.get(featureKey) || "";

  // feature key not found, return undefined
  if (!rawValue) {
    return undefined;
  }

  // Type-safe value parsing based on feature type
  if (featureType === "boolean") {
    const rawValueNormalized = rawValue.toLocaleLowerCase();
    if (rawValueNormalized === "true" || rawValueNormalized === "false") {
      return rawValue.toLowerCase() === "true";
    }
  }

  if (featureType === "number") {
    const numValue = parseFloat(rawValue);
    if (!isNaN(numValue)) {
      return numValue;
    }
  }

  if (featureType === "string") {
    if (typeof rawValue === "string") {
      return rawValue;
    }
  }

  console.warn(
    `feature key ${featureKey} did not match expected type: ${featureType}`,
  );
  return undefined;
}
